(ns teamoesterreich.event-mode.event-page
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.link :refer [link]]
            [reagent-material-ui.icons.person :refer [person]]
            [reagent-material-ui.icons.phone-iphone :refer [phone-iphone]]
            [reagent.core :as r]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.lebensretter-checks :as h-check]
            [teamoesterreich.store :as store]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.markdown :refer [md md-form]]
            [teamoesterreich.config :as config]
            ["react-qr-code" :default QRCode]
            [teamoesterreich.util.log :as log]))


(defn fbDate-2-local-date [fb-date]
      (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds ^js fb-date)))))


(defn info-part [!actual-user switch-page]
      [:<>
       [mui/grid
        {:container false
         :item      true
         :xs        12                                      ;extra-small: 0px
         :style     {:padding "15px"}}
        [:h1
         "Voraussetzungen"]

        [:div {:class "helping-check-line"}
         [:div {:class "check-line-icon"}
          (if (h-check/check-profile? @!actual-user) [check] [close])]
         [:div {:class "check-line-text"}
          "Vollständig ausgefülltes Profil"
          [:br]
          (when-not (h-check/check-profile? @!actual-user)
                    [mui/typography {:color "error" :variant "body2"} "Es fehlt: " (:profile-incomplete-hint @!actual-user)])]
         [mui/button {:variant   "outlined" :color "primary"
                      :startIcon (r/as-element [person])
                      :onClick   #(switch-page :profile)}
          "Zu meinem Profil"]]

        [:div {:class "helping-check-line"}
         [:div {:class "check-line-icon"}
          (if (h-check/check-email? @!actual-user) [check] [close])]
         [:div {:class "check-line-text"}
          "Email validiert"]]

        [:div {:class "helping-check-line"}
         [:div {:class "check-line-icon"}
          (if (h-check/check-handy? @!actual-user) [check] [close])]
         [:div {:class "check-line-text"}
          "Handynummer validiert"]]

        [:div {:class "helping-check-line"}
         [:div {:class "check-line-icon"}
          (if (h-check/check-identity? @!actual-user) [check] [close])]
         [:div {:class "check-line-text"}
          "Identität bestätigt"]]
        ]
       ])

(defn event-part [!actual-user !d-event-info switch-page]
      (let [!d-event (r/cursor !d-event-info [:event])
            !d-member (r/cursor !d-event-info [:member])]
           [mui/grid
            {:container false
             :item      true
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "15px"}}

            [mui/card-content
             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "center"
               :alignItems "stretch"
               :spacing    5
               :style      {:marginTop "15px"}
               }
              [mui/grid
               {:container false
                :item      true
                :xl        6
                :lg        8
                :xs        12
                }

               ;[:pre (pr-str (:event @!d-event-info))]
               ;[:pre (pr-str (:member @!d-event-info))]

               [:h2 "Einsatz: `" (:crowdtaskerEvent-name @!d-event) "` "]

               (when (:crowdtaskerEventMember-consentSignature @!d-member)
                     [:div {:style {:width "100%" :text-align "center"}}
                      "QR Code für CHECKIN "                ;(get-in @!actual-user [:tom-id])
                      [:br]
                      [:> QRCode {:value   (str "https://crowdtask.toe2.erik-4g.bolldorf.com/points/event-checkin?tomId=" (get-in @!actual-user [:tom-id])
                                                "&event-uuid=" (:crowdtaskerEvent-uuid @!d-event)
                                                "&member-control=" (:crowdtaskerEventMember-control @!d-member))
                                  :size    180
                                  :level   "M"              ; Error correction levels: 'L', 'M', 'Q', 'H'
                                  :fgColor "#2c3e50"
                                  :bgColor "#ffffff"}]
                      ])
               ]

              [mui/grid
               {:container false
                :item      true
                :lg        8
                :xs        12
                :style     {:text-align "left" :border "1px dotted "}
                }
               [mui/form-control
                [mui/form-label "Ort:"]
                (:crowdtaskerEvent-locationName @!d-event)]]

              [mui/grid
               {:container false
                :item      true
                :lg        8
                :xs        12
                :style     {:text-align "left" :border "1px dotted "}
                }
               [mui/form-control
                [mui/form-label "Tätigkeit:"]
                (:crowdtaskerEvent-descriptionTask @!d-event)]]

              [mui/grid
               {:container false
                :item      true
                :lg        8
                :xs        12
                :style     {:text-align "left" :border "1px dotted "}
                }
               [mui/form-control
                [mui/form-label "Mitzubringen:"]
                (:crowdtaskerEvent-descriptionBring @!d-event)]]


              ;:crowdtaskerEvent-descriptionBring
              ;:crowdtaskerEvent-descriptionTask
              ;:crowdtaskerEvent-descriptionContact
              ;:crowdtaskerEvent-descriptionPickup

              [mui/grid
               {:container false
                :item      true
                :lg        8
                :xs        12
                :style     {:text-align "left" :border "1px dotted "}
                }
               [mui/form-control
                [mui/form-label "Einsatz Beschreibung:"]
                [:div {:style {:max-width "800px"}
                       :dangerouslySetInnerHTML
                       {:__html
                        (try
                          (.render md
                                 (:crowdtaskerEvent-description @!d-event))
                          (catch js/Error e ""))
                        }}]

                ]
               ]
              (cond
                (not= "accepted" (:crowdtaskerEventMember-responseState @!d-member))
                [mui/grid
                 {:container false
                  :item      true
                  :lg        8
                  :xs        12
                  :style     {:text-align "left" :border "1px dotted "}
                  }
                 (if true; (:_allowed @!d-event) ;; TODO
                   [mui/button
                    {:style   {:width "160px" :margin "5px"}
                     :variant "contained"
                     :color   "secondary"
                     :onClick (fn [])
                     }
                    "Zusagen"]
                   [:<>
                    [:span {:style {:color "darkred"}} "Du erfüllst leider nicht die Voraussetzungen für diesen Einsatz"]
                    [mui/button
                     {:style   {:width "160px" :margin "5px"}
                      :variant "contained"
                      :color   "secondary"
                      :onClick (fn [])
                      }
                     "Ausnahme anfragen"]])
                 ]

                (not (:crowdtaskerEventMember-consentSignature @!d-member))
                [mui/grid
                 {:container false
                  :item      true
                  :lg        8
                  :xs        12
                  :style     {:text-align "left" :border "1px dotted "}
                  }
                 [mui/form-control
                  [mui/form-label "Einverständniserklärung:"]


                  [:div {:style {:max-width "800px"}}
                   [md-form (:crowdtaskerEvent-consentForm @!d-event)
                    (fn [answers sign]
                        (a/set-user-crowdtasker-response (:crowdtaskerEvent-uuid @!d-event)
                                                         {:accept-timestamp (js/Date.)
                                                          :accept-device    "Browser"
                                                          :consent          true
                                                          :answers          answers
                                                          :sign             sign
                                                          }))]]
                  ]
                 ]
                :else
                [mui/grid
                 {:container false
                  :item      true
                  :lg        8
                  :xs        12
                  :style     {:text-align "left" :border "1px dotted "}
                  }
                 [:br]
                 [:div
                  "Ich habe die Erklärung unterschrieben (QR Code kommt auch per EMail)"
                  [:br]

                  ]
                 ]
                )
              [mui/grid
               {:container false
                :item      true
                :lg        8
                :xs        12
                }
               [:br]
               [:br]
               [:br]]]

             ]]))

(defn get-it [switch-page event-uuid]
      (let [!actual-user (r/cursor store/app-state [:actual-user])
            !d-event-info (r/atom nil)
            prereq true
            ]
           (fn [switch-page event-uuid]

               (when (nil? @!d-event-info)
                     (reset! !d-event-info :loading)
                     (a/get-user-crowdtasker-response event-uuid (:tom-id @!actual-user)
                                                      (fn [d]
                                                          (println " BODY" d)
                                                          (reset! !d-event-info d))
                                                      #(reset! !d-event-info false)))
               [mui/grid
                {:container  true
                 :direction  "column"
                 :justify    "center"
                 :alignItems "center"
                 :spacing    4
                 :style      {:marginTop "10px"}}

                [mui/grid
                 {:container false
                  :item      true
                  :md        6                              ;medium: 960px
                  :xs        12                             ;extra-small: 0px
                  }
                 [mui/paper {:class ""
                             :style {:textAlign "left" :padding "25px"}}

                  (cond
                    (false? @!d-event-info)
                    [:<>
                     [:h3 (str "Einsatz nicht gefunden")]]



                    (:event @!d-event-info)
                    [mui/grid
                     {:container  true
                      :direction  "row"
                      :justify    "space-between"
                      :alignItems "flex-start"
                      :spacing    1}

                     (when-not prereq
                               [mui/grid
                                {:container false
                                 :item      true
                                 :xs        12              ;extra-small: 0px
                                 :style     {:padding "15px"}}
                                [info-part !actual-user switch-page]
                                ])
                     [event-part !actual-user !d-event-info switch-page]]

                    :else
                    [:<>
                     [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
                     [:h3 (str "Lade den Einsatz")]]
                    )

                  ]]]

               )))


